import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { MvcControllerInfo, MvcAreaInfo } from "projects/sepidz-web-framework/src/lib/models/MvcControllerInfo.model";
import { Role, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { take, takeUntil } from "rxjs/operators";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { UntypedFormControl } from "@angular/forms";
import { TreeviewConfig, TreeviewItem } from "projects/ngx-treeview/src/lib";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { LocalStoreManager } from "../../../../../projects/sepidz-web-framework/src/lib/services";
import { CheckBrachAccessModel } from "../../data-center-process/chek-branch-access.model";
export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

@Component({
  selector: "ngx-role-form",
  templateUrl: "./role-form.component.html",
  styleUrls: ["./role-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleFormComponent extends BaseFormComponent<Role> {
  apiName = "Role";
  erroremessage: string;
  columns: form_control[] = [];
  _config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 400,
  });
  items: TreeviewItem[] = [];
  values: string[];
  deactivateSave: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public localStorage: LocalStoreManager) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.label = this.translate("ClientApp.GNR.Role.UsersRole");
    super.ngOnInit();
    this.pupulateitems();
  }
  setdefault() {
    this.pupulateitems();
    const info = this.accountService.authService.currentInformation();
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch/Security")
        .pipe(take(1))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(this.translate("ClientApp.GNR.Role.InfoBranchCanNotDeleted"), this.translate("ClientApp.GNR.Role.Attention"));
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.GNR.Role.InfoCentralOfficeCanNotDeleted"),
                  this.translate("ClientApp.GNR.Role.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }
  }
  async setColumns() {
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.Role.Name"),
      name: "Name",
      order: 0,
      listVisible: true,
      formVisible: true,
      placeholder: this.translate("ClientApp.GNR.Role.EnterRole"),
      required: true,
      textType: "text",
      modelName: "Name",
      maxLength: 256,
      controlType: FormControlTypes.textbox,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.Role.DisplayName"),
      name: "DisplayName",
      order: 1,
      listVisible: true,
      formVisible: true,
      placeholder: this.translate("ClientApp.GNR.Role.EnterDescription"),
      required: true,
      textType: "text",
      modelName: "DisplayName",
      controlType: FormControlTypes.textbox,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.Role.Description"),
      name: "Description",
      order: 2,
      listVisible: true,
      formVisible: true,
      placeholder: this.translate("ClientApp.GNR.Role.EnterDescription"),
      required: false,
      textType: "text",
      modelName: "Description",
      controlType: FormControlTypes.textbox,
      disabled: false,
    });

    this.orignalColumns = this.columns;
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.setColumnNumber(this.columns);
    this.setColumnAttribute();
    this.setFormGroup(this.model);
  }
  getAccessList(): string {
    var accessList: MvcAreaInfo[] = [];
    let _values = this.values;
    this.accountService.authService
      .userControllers()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((controllers) => {
        if (controllers && controllers.length > 0 && this.values && this.values.length > 0) {
          controllers.forEach((a) => {
            let currentArea: MvcAreaInfo = <MvcAreaInfo>{ Name: a.Name, DisplayName: a.DisplayName, Id: a.Id, Controllers: [] };
            if (a.Controllers) {
              a.Controllers.forEach((c) => {
                let controller: MvcControllerInfo = <MvcControllerInfo>{
                  AreaName: c.AreaName,
                  DisplayName: c.DisplayName,
                  Id: c.Id,
                  Name: c.Name,
                  Actions: [],
                };
                if (c.Actions) {
                  c.Actions.forEach((a) => {
                    let action = _values.find((v) => v === a.Id);
                    if (!isNullOrUndefined(action)) controller.Actions.push(a);
                  });
                }
                if (controller && controller.Actions && controller.Actions.length > 0) currentArea.Controllers.push(controller);
              });
            }
            if (currentArea && currentArea.Controllers && currentArea.Controllers.length > 0) accessList.push(currentArea);
          });
        }
      });
    return JSON.stringify(accessList);
  }
  addControl() {
    this.cd.markForCheck();
  }

  public beforupdate() {
    let access = this.getAccessList();
    if (access) {
      this.model.Access = access;
      if (!this.formGroup.controls["Access"]) this.formGroup.addControl("Access", new UntypedFormControl(this.model.Access));
      else this.formGroup.controls["Access"].setValue(this.model.Access);
    }
  }
  pupulateitems() {
    this.accountService.authService
      .userControllers()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((controllers) => {
        var accessList: MvcAreaInfo[] = this.model.Access ? JSON.parse(this.model.Access) : [];
        this.items = [];
        controllers.forEach((a) => {
          let children1: any[] = [];
          if (a.Controllers) {
            a.Controllers.forEach((c) => {
              let children: any[] = [];
              if (c.Actions) {
                c.Actions.forEach((a) => {
                  let actions = {
                    value: a.Id,
                    checked: accessList.some((x) => x.Controllers && x.Controllers.some((c) => c.Actions.some((a2) => a2.Id === a.Id))),
                    text: a.DisplayName ? a.DisplayName : a.Name,
                  };
                  children.push(actions);
                });
              }
              let item = new TreeviewItem({ value: c.Id, collapsed: true, text: c.DisplayName ? c.DisplayName : c.Name, children: children });
              children1.push(item);
            });
            let item2 = new TreeviewItem({ value: a.Id, collapsed: true, text: a.DisplayName ? a.DisplayName : a.Name, children: children1 });
            this.items.push(item2);
          }
        });
      });
  }
  async afterupdate() {
    const authService = this.accountService.authService;
    await authService.getLoginUserRoles(authService.currentUser.UserName).then();
  }

  close() {
    super.close();
  }
}
